import React, { useEffect, useState } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import { UploadProvider } from 'context'
import { axios } from 'api'
import { Flex, Loading, Spinner } from 'ui/bend'

const BillboardShow = React.lazy(() =>
  import(
    /* webpackChunkName: 'admin-billboard-show' */ 'components_v2/Admin/Billboard/Show'
  )
)

const StyledBillboardShow = ({ id, existingBillboards }) => {
  const [billboard, setBillboard] = useState()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  /* 
    We don't employ useFetchAPI() here, because its default behavior with null url is to remain in the Loading state.
    This will therefore never load for a new billboard (as no id url will ever be set).

    TODO: rework useFetchAPI() to accommodate a null url state that triggers a loading: false state.
  */

  useEffect(() => {
    const fetchBillboard = async () => {
      try {
        const res = await axios.get(`/billboards/${id}`, {
          baseURL: '/admin/api',
          params: { version: 1 }
        })
        if (res && res.data) {
          const data = {
            ...res.data,
            contentIdItems: [],
            contentId: res.data.ctaAction?.data?.contentId || '',
            contentType: res.data.ctaAction?.data?.contentType || 'series',
            priority: res.data.priority,
            id
          }

          setBillboard(data)
        }
      } catch (error) {
        if (error.response.status === 404) {
          setError('There was no billboard associated with this slug')
        } else {
          setError('There has been an error, please contact Engineering')
        }
      } finally {
        setLoading(false)
      }
    }
    if (id) {
      fetchBillboard()
    } else {
      setLoading(false)
    }
  }, [id])

  return (
    <StyledAdminWrapper>
      <UploadProvider>
        <Loading
          loading={loading}
          error={Boolean(error)}
          LoadingComponent={
            <Flex
              height='100vh'
              width={['100%', '75%']}
              alignItems='center'
              justifyContent='center'
            >
              <Spinner />
            </Flex>
          }
          ErrorComponent={<Flex>{error}</Flex>}
        >
          <BillboardShow
            initialValues={billboard}
            existingBillboards={existingBillboards}
          />
        </Loading>
      </UploadProvider>
    </StyledAdminWrapper>
  )
}

export default StyledBillboardShow
